export default __webpack_public_path__ + "images/2847577970566ad8e51c3c8b4fe90657.png";